const BACKEND_RESPONSE = {
  GENERAL: {
    ERROR: {
      UNKNOWN_ERROR: {
        status: 400,
        success: false,
        message: "An error occurred. Please try again.",
        i18nKey: "backend.auth.unknownerror",
      },
      FIELDS_MISSING: {
        status: 400,
        success: false,
        message: "Please add all fields.",
        i18nKey: "backend.general.error.fields_missing",
      },
    },
  },
  AUTH: {
    NOT_AUTHORIZED: {
      status: 403,
      success: false,
      message: "Not authorized",
      i18nKey: "backend.auth.not_authorized",
    },
    TOKEN_EXPIRED: {
      status: 401,
      success: false,
      message: "Token expired",
      i18nKey: "backend.auth.token_expired",
    },
  },
  USER: {
    USER_EMAIL_EXISTS: {
      SUCCESS: {
        status: 200,
        success: true,
        message: "Email successfully checked",
        i18nKey: "backend.user.user_email_exists.success",
      },
    },
    LOGIN: {
      ERROR: {
        NO_CREDENTIALS_PROVIDED: {
          status: 400,
          success: false,
          message: "No credentials provided",
          i18nKey: "backend.user.client.login.error.no_credentials_provided",
        },
        USER_NOT_FOUND: {
          status: 400,
          success: false,
          message: "Email not found",
          i18nKey: "backend.user.client.login.error.email_not_found",
        },
        INCORRECT_PASSWORD: {
          status: 400,
          success: false,
          message: "Incorrect password",
          i18nKey: "backend.user.client.login.error.incorrect_password",
        },
        INCORRECT_EMAIL_OR_PASSWORD: {
          status: 400,
          success: false,
          message: "Incorrect email or password",
          i18nKey:
            "backend.user.client.login.error.incorrect_email_or_password",
        },
        USER_BLOCKED: {
          status: 403,
          success: false,
          message:
            "Your account has been disabled. Please contact your administrator or us.",
          i18nKey: "backend.user.login.error.user_blocked",
        },
      },
    },
    GET_ME: {
      ERROR: {
        USER_NOT_FOUND: {
          status: 400,
          success: false,
          message: "User not found",
          i18nKey: "backend.user.get_me.error.user_not_found",
        },
      },
      SUCCESS: {
        status: 200,
        success: true,
        message: "User data fetched successfully",
        i18nKey: "backend.user.get_me.success",
      },
    },
    GENERAL: {
      ERROR: {
        USER_TYPE_NOT_FOUND: {
          status: 401,
          success: false,
          message: "User type not valid",
          i18nKey: "backend.auth.login.error.user_type_not_valid",
        },
        INVALID_EMAIL: {
          status: 400,
          success: false,
          message: "Invalid email",
          i18nKey: "backend.user.client.validate.error.invalid_email",
        },
        USER_ALREADY_EXISTS: {
          status: 400,
          success: false,
          message: "This email address is already taken",
          i18nKey: "backend.user.client.validate.error.user_already_exists",
        },
        PASSWORDS_DO_NOT_MATCH: {
          status: 400,
          success: false,
          message: "Passwords do not match.",
          i18nKey: "backend.user.client.validate.error.passwords_do_not_match",
        },
        PASSWORD_NOT_VALID: {
          status: 400,
          success: false,
          message: "Password is not valid.",
          i18nKey: "backend.user.client.validate.error.password_not_valid",
        },
      },
    },
    CLIENT: {
      VERIFY_CLIENT_EMAIL: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client email verified successfully",
          i18nKey: "backend.user.client.verify_client_email.success",
        },
        ERROR: {
          EMAIL_VERIFICATION_FAILED: {
            status: 400,
            success: false,
            message: "Email verification failed",
            i18nKey:
              "backend.user.client.verify_client_email.error.email_verification_failed",
          },
          EMAIL_ALREADY_VERIFIED: {
            status: 400,
            success: false,
            message: "Email already verified",
            i18nKey:
              "backend.user.client.verify_client_email.error.email_already_verified",
          },
          EMAIL_VERIFICATION_NO_USER_FOUND: {
            status: 400,
            success: false,
            message: "No user found for the provided email",
            i18nKey:
              "backend.user.client.verify_client_email.error.email_verification_no_user_found",
          },
        },
      },
      REGISTER: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client registered successfully",
          i18nKey: "backend.user.client.register.success",
        },
        ERROR: {
          FAILED_TO_HANDLE_CLIENT_DATA: {
            status: 400,
            success: false,
            message: "Failed to handle client data",
            i18nKey: "backend.user.client.error.failed_to_handle_client_data",
          },
          FAILED_TO_CREATE_CLIENT: {
            status: 400,
            success: false,
            message: "Failed to create client",
            i18nKey: "backend.user.client.error.failed_to_create_client",
          },
        },
      },
      REQUEST_CLIENT_EMAIL_VERIFICATION: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client email verification request sent successfully",
          i18nKey:
            "backend.user.client.request_client_email_verification.success",
        },
        ERROR: {
          FAILED_TO_SEND_EMAIL: {
            status: 400,
            success: false,
            message: "Failed to send email verification request",
            i18nKey:
              "backend.user.client.request_client_email_verification.error.failed_to_send_email",
          },
        },
      },
      REQUEST_CLIENT_PASSWORD_RESET: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client password reset request sent successfully",
          i18nKey: "backend.user.client.request_client_password_reset.success",
        },
        ERROR: {
          FAILED_TO_SEND_EMAIL: {
            status: 400,
            success: false,
            message: "Failed to send password reset request",
            i18nKey:
              "backend.user.client.request_client_password_reset.error.failed_to_send_email",
          },
        },
      },
      RESET_CLIENT_PASSWORD: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client password reset successfully",
        },
        ERROR: {
          WRONG_OR_NO_TOKEN_PROVIDED: {
            status: 400,
            success: false,
            message: "Wrong or no token provided",
            i18nKey:
              "backend.user.client.reset_client_password.error.wrong_or_no_token_provided",
          },
          USER_NOT_FOUND: {
            status: 400,
            success: false,
            message: "User not found",
            i18nKey:
              "backend.user.client.reset_client_password.error.user_not_found",
          },
          FAILED_TO_RESET_PASSWORD: {
            status: 400,
            success: false,
            message: "Failed to reset password",
            i18nKey:
              "backend.user.client.reset_client_password.error.failed_to_reset_password",
          },
        },
      },
      LOGIN: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client logged in successfully",
          i18nKey: "backend.user.client.login.success",
        },
        ERROR: {
          ACCOUNT_BLOCKED: {
            status: 400,
            success: false,
            message:
              "Your account was blocked by your company. Please contact your company owner or administrator.",
            i18nKey: "backend.user.client.login.error.account_blocked",
          },
          ACCOUNT_DISABLED: {
            status: 403,
            success: false,
            message:
              "Your account has been disabled. Please contact us for assistance.",
            i18nKey: "backend.user.client.login.error.account_disabled",
          },
          EMAIL_NOT_VERIFIED: {
            status: 400,
            success: false,
            message: "Email not verified",
            i18nKey: "backend.user.client.login.error.email_not_verified",
          },
        },
      },
      LOGOUT: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Client logged out successfully",
          i18nKey: "backend.user.client.logout.success",
        },
      },

      ACCOUNT_UPDATE: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Account updated successfully",
          i18nKey: "backend.user.client.account_update.success",
        },
        ERROR: {
          ACCOUNT_UPDATE_FAILED: {
            status: 400,
            success: false,
            message: "Account update failed",
            i18nKey:
              "backend.user.client.account_update.error.account_update_failed",
          },
        },
      },
      PROFILE_UPDATE: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Profile updated successfully",
          i18nKey: "backend.user.client.profile_update.success",
        },
        ERROR: {
          PROFILE_UPDATE_FAILED: {
            status: 400,
            success: false,
            message: "Profile update failed",
            i18nKey:
              "backend.user.client.profile_update.error.profile_update_failed",
          },
        },
      },
      ORGANIZATION: {
        ERROR: {
          MAX_DELIVERYADDRESSES_FOR_ROLE_NONE: {
            status: 400,
            success: false,
            message:
              "You have reached the maximum number of delivery addresses for this role",
            i18nKey:
              "backend.user.client.organization.error.max_deliveryaddresses_for_role_none",
          },
          ORGANIZATION_NOT_FOUND: {
            status: 400,
            success: false,
            message: "Organization not found",
            i18nKey:
              "backend.user.client.organization.error.organization_not_found",
          },
          SUBSCRIPTION_NOT_FOUND: {
            status: 400,
            success: false,
            message: "Subscription not found",
            i18nKey:
              "backend.user.client.organization.error.subscription_not_found",
          },
          EVENT_NOT_ACTIVE: {
            status: 400,
            success: false,
            message: "Event not active",
            i18nKey: "backend.user.client.organization.error.event_not_active",
          },

          FAILED_TO_GET_EVENT_GUEST: {
            status: 400,
            success: false,
            message: "Failed to get event guest",
            i18nKey:
              "backend.user.client.organization.error.failed_to_get_event_guest",
          },
          FAILED_TO_GET_ORDER_DETAILS: {
            status: 400,
            success: false,
            message: "Failed to get order details",
            i18nKey:
              "backend.user.client.organization.error.failed_to_get_order_details",
          },
          VAT_INVALID_BY_VIES_API: {
            status: 400,
            success: false,
            message: "VAT is invalid according to the VIES API",
            i18nKey: "backend.user.client.organization.error.vat_invalid",
          },
          COULD_NOT_VALIDATE_VAT_BY_VIES_API: {
            status: 400,
            success: false,
            message: "Could not validate VAT by VIES API",
            i18nKey: "backend.user.client.organization.error.could_not_validate_vat_by_vies_api",
          },
          INVALID_ORGANIZATION_ROLE: {
            status: 400,
            success: false,
            message: "Invalid organization role",
            i18nKey:
              "backend.user.client.organization.error.invalid_organization_role",
          },
          NOT_AN_ADMIN: {
            status: 400,
            success: false,
            message: "You are not an admin or owner of this organization",
            i18nKey: "backend.user.client.organization.error.not_an_admin",
          },
          VAT_REQUIRED: {
            status: 400,
            success: false,
            message: "VAT is required",
            i18nKey: "backend.user.client.organization.error.vat_required",
          },
          KBO_REQUIRED: {
            status: 400,
            success: false,
            message: "KBO is required",
            i18nKey: "backend.user.client.organization.error.kbo_required",
          },
          CNO_REQUIRED: {
            status: 400,
            success: false,
            message: "Customer number is required",
            i18nKey: "backend.user.client.organization.error.cno_required",
          },
          NO_COMPANY_IDENTIFIER_PROVIDED: {
            status: 400,
            success: false,
            message: "No company identifier provided",
            i18nKey:
              "backend.user.client.organization.error.no_company_identifier_provided",
          },
          COMPANY_OBJID_NOT_FOUND: {
            status: 400,
            success: false,
            message: "Company objid not found",
            i18nKey:
              "backend.user.client.organization.error.company_objid_not_found",
          },
          CANNOT_FIND_COMPANY_CONTACT: {
            status: 400,
            success: false,
            message:
              "Cannot find company contact with provided companyContactObjId",
            i18nKey:
              "backend.user.client.organization.error.cannot_find_company_contact_with_companyContactObjId",
          },
          COMPANY_CONTACT_ALREADY_EXISTS_FOR_VAT_OR_KBO: {
            status: 400,
            success: false,
            message:
              "You are trying to register a new company contact with an existing VAT or KBO.",
            i18nKey:
              "backend.user.client.organization.error.company_contact_already_exists_for_vat_or_kbo",
          },
          ERROR_CREATING_COMPANY_CONTACT: {
            status: 400,
            success: false,
            message: "Error creating company contact",
            i18nKey:
              "backend.user.client.organization.error.error_creating_company_contact",
          },
          ERROR_UPDATING_COMPANY_CONTACT: {
            status: 400,
            success: false,
            message: "Error updating company contact",
            i18nKey:
              "backend.user.client.organization.error.error_updating_company_contact",
          },
          ERROR_UPDATING_COMPANY_CONTACT_ADDRESS: {
            status: 400,
            success: false,
            message: "Error updating company contact address",
            i18nKey:
              "backend.user.client.organization.error.error_updating_company_contact_address",
          },
          FAILED_TO_GET_ORGANIZATION: {
            status: 400,
            success: false,
            message: "Failed to get organization",
            i18nKey:
              "backend.user.client.organization.error.failed_to_get_organization",
          },
          FAILED_TO_SYNC_CONTACTS: {
            status: 400,
            success: false,
            message: "Failed to sync contacts",
            i18nKey:
              "backend.user.client.organization.error.failed_to_sync_contacts",
          },
          ERROR_CREATING_CONTACT_PERSON: {
            status: 400,
            success: false,
            message: "Error creating contact person",
            i18nKey:
              "backend.user.client.organization.error.error_creating_contact_person",
          },
          ERROR_SETTING_CONTACT_INACTIVE: {
            status: 400,
            success: false,
            message: "Error setting contact inactive",
            i18nKey:
              "backend.user.client.organization.error.error_setting_contact_inactive",
          },
          THIS_IS_NOT_YOUR_COMPANY_ADDRESS: {
            status: 400,
            success: false,
            message: "This is not your company address",
            i18nKey:
              "backend.user.client.organization.error.this_is_not_your_company_address",
          },
          YOU_CANNOT_DELETE_YOUR_MAIN_COMPANY_ADDRESS: {
            status: 400,
            success: false,
            message: "You cannot delete your main company address",
            i18nKey:
              "backend.user.client.organization.error.you_cannot_delete_your_main_company_address",
          },
          ORGANIZATION_MEMBER_VERIFICATION_FAILED: {
            status: 400,
            success: false,
            message: "Organization member verification failed",
            i18nKey:
              "backend.user.client.organization.error.organization_member_verification_failed",
          },
        },

        VERIFY_ORGANIZATION_MEMBER: {
          SUCCESS: {
            status: 200,
            success: true,
            message: "Organization member verified successfully",
            i18nKey:
              "backend.user.client.organization.verify_organization_member.success",
          },
          ALREADY_VERIFIED: {
            status: 200,
            success: true,
            message: "Organization member is already verified",
            i18nKey:
              "backend.user.client.organization.verify_organization_member.already_verified",
          },
        },

        UPDATE: {
          SUCCESS: {
            status: 200,
            success: true,
            message: "Organization updated successfully",
            i18nKey: "backend.user.client.organization.update.success",
          },
          ERROR: {
            ORGANIZATION_UPDATE_FAILED: {
              status: 400,
              success: false,
              message: "Organization update failed",
              i18nKey:
                "backend.user.client.organization.update.error.organization_update_failed",
            },
          },
        },
      },
    },
    EMPLOYEE: {
      LOGIN: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Employee logged in successfully",
          i18nKey: "backend.user.employee.login.success",
        },
      },
      LOGIN_AS_USER: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Employee logged in successfully as another user",
          i18nKey: "backend.user.employee.login_as_user.success",
        },
      },
      LOGOUT: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Employee logged out successfully",
          i18nKey: "backend.user.employee.logout.success",
        },
      },
    },
  },
  ECOMMERCE: {
    PAYMENT: {
      MSP: {
        CREATE_PAYMENT: {
          SUCCESS: {
            status: 200,
            success: true,
            message: "Payment created successfully",
            i18nKey: "backend.ecommerce.payment.msp.create_payment.success",
          },
          ERROR: {
            SESSION_ID_MISSING: {
              status: 400,
              success: false,
              message: "Session ID missing",
              i18nKey:
                "backend.ecommerce.payment.msp.create_payment.error.session_id_missing",
            },
            PAYMENT_METHOD_NOT_FOUND: {
              status: 400,
              success: false,
              message: "Payment method not found",
              i18nKey:
                "backend.ecommerce.payment.msp.create_payment.error.payment_method_not_found",
            },
            CART_NOT_FOUND: {
              status: 400,
              success: false,
              message: "Cart not found",
              i18nKey:
                "backend.ecommerce.payment.msp.create_payment.error.cart_not_found",
            },
            PAYMENT_CREATION_FAILED: {
              status: 400,
              success: false,
              message: "Payment creation failed",
              i18nKey:
                "backend.ecommerce.payment.msp.create_payment.error.payment_creation_failed",
            },
          },
        },
        NOTIFICATION: {
          SUCCESS: {
            status: 200,
            success: true,
            message: "Payment notification received successfully",
            i18nKey: "backend.ecommerce.payment.msp.notification.success",
          },
        },
      },
    },
    CART: {
      DELETE_FAVORITE_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Favorite cart deleted successfully",
          i18nKey: "backend.ecommerce.cart.delete_favorite_cart.success",
        },
        ERROR: {
          CART_NOT_FOUND: {
            status: 400,
            success: false,
            message: "Cart not found",
            i18nKey: "backend.ecommerce.cart.error.cart_not_found",
          },
        },
      },

      REQUEST_QUOTE: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Quote requested successfully",
          i18nKey: "backend.ecommerce.cart.request_quote.success",
        },
        ERROR: {
          REQUEST_QUOTE_FAILED: {
            status: 400,
            success: false,
            message: "Request quote failed",
            i18nKey:
              "backend.ecommerce.cart.request_quote.error.request_quote_failed",
          },
        },
      },
      GET_FAVORITE_CARTS: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Favorite carts fetched successfully",
          i18nKey: "backend.ecommerce.cart.get_favorite_carts.success",
        },
      },
      APPLY_DISCOUNT_CODE: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Discount code applied successfully",
          i18nKey: "backend.ecommerce.cart.apply_discount_code.success",
        },
        ERROR: {
          DISCOUNT_CODE_NOT_VALID: {
            status: 400,
            success: false,
            message: "Discount code not valid",
            i18nKey:
              "backend.ecommerce.cart.apply_discount_code.error.discount_code_not_valid",
          },
          ARTICLE_NOT_FOUND: {
            status: 400,
            success: false,
            message: "Article not found",
            i18nKey:
              "backend.ecommerce.cart.apply_discount_code.error.article_not_found",
          },
        },
      },
      QUOTE_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart quoted successfully",
          i18nKey: "backend.ecommerce.cart.quote_cart.success",
        },
      },
      CLEAR_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart cleared successfully",
          i18nKey: "backend.ecommerce.cart.clear_cart.success",
        },
      },
      ADD_TO_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart updated successfully",
          i18nKey: "backend.ecommerce.cart.add_to_cart.success",
        },
      },
      REMOVE_FROM_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Item removed from cart successfully",
          i18nKey: "backend.ecommerce.cart.remove_from_cart.success",
        },
      },
      UPDATE_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart updated successfully",
          i18nKey: "backend.ecommerce.cart.update_cart.success",
        },
      },
      GET_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart fetched successfully",
          i18nKey: "backend.ecommerce.cart.get_cart.success",
        },
      },
      SET_CART_PICKUP_OR_DELIVERY_TERM_CODE: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart pickup or delivery term code set successfully",
          i18nKey:
            "backend.ecommerce.cart.set_cart_pickup_or_delivery_term_code.success",
        },
      },
      SET_CART_PAYMENT_METHOD: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Cart payment method set successfully",
          i18nKey: "backend.ecommerce.cart.set_cart_payment_method.success",
        },
      },
      GET_PAYMENT_CONDITIONS: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Payment conditions fetched successfully",
          i18nKey: "backend.ecommerce.cart.get_payment_conditions.success",
        },
      },
      ORDER: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Order created successfully",
          i18nKey: "backend.ecommerce.cart.order.success",
        },
      },
      PAY_ORDER: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Order paid successfully",
          i18nKey: "backend.ecommerce.cart.pay_order.success",
        },
      },
      CREATE_FAVORITE_CART: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Favorite cart created successfully",
          i18nKey: "backend.ecommerce.cart.create_favorite_cart.success",
        },
        ERROR: {
          CART_NAME_REQUIRED: {
            status: 400,
            success: false,
            message: "Cart name is required",
            i18nKey:
              "backend.ecommerce.cart.create_favorite_cart.error.cart_name_required",
          },
        },
        CLIENT_ID_REQUIRED: {
          status: 400,
          success: false,
          message: "Client ID is required",
          i18nKey:
            "backend.ecommerce.cart.create_favorite_cart.error.client_id_required",
        },
      },
      EDIT_FAVORITE_CART_NAME: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Favorite cart name updated successfully",
          i18nKey: "backend.ecommerce.cart.edit_favorite_cart_name.success",
        },
      },
      ERROR: {
        DELIVERY_TERM_NOT_FOUND: {
          status: 404,
          success: false,
          message: "Delivery term not found",
          i18nKey: "backend.ecommerce.cart.error.delivery_term_not_found",
        },
        CART_NOT_FOUND: {
          status: 404,
          success: false,
          message: "Cart not found",
          i18nKey: "backend.ecommerce.cart.error.cart_not_found",
        },
        NO_ITEMS_IN_CART: {
          status: 404,
          success: false,
          message: "No items in cart",
          i18nKey: "backend.ecommerce.cart.error.no_items_in_cart",
        },
        CART_NOT_OPEN: {
          status: 400,
          success: false,
          message: "Cart is not open",
          i18nKey: "backend.ecommerce.cart.error.cart_not_open",
        },
        NO_CLIENT_ID: {
          status: 400,
          success: false,
          message: "No client ID",
          i18nKey: "backend.ecommerce.cart.error.no_client_id",
        },
        FAILED_TO_CREATE_CART: {
          status: 400,
          success: false,
          message: "Failed to create cart",
          i18nKey: "backend.ecommerce.cart.error.failed_to_create_cart",
        },
        CART_ID_REQUIRED_FOR_FAVORITES: {
          status: 400,
          success: false,
          message: "Cart ID required for favorites",
          i18nKey:
            "backend.ecommerce.cart.error.cart_id_required_for_favorites",
        },

        CLIENT_ID_OR_SESSION_ID_REQUIRED: {
          status: 400,
          success: false,
          message: "Client ID or session ID required",
          i18nKey:
            "backend.ecommerce.cart.error.client_id_or_session_id_required",
        },
      },
    },
    ORDER: {
      GET_CUSTOMER_ORDERS: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Customer orders fetched successfully",
          i18nKey: "backend.ecommerce.order.get_customer_orders.success",
        },
      },
      GET_ORDER_STATUS: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Order status fetched successfully",
          i18nKey: "backend.ecommerce.order.get_order_status.success",
        },
      },
      ERROR: {
        CHECKOUT_NOT_ENABLED: {
          status: 400,
          success: false,
          message: "Checkout not enabled",
          i18nKey: "backend.ecommerce.order.error.checkout_not_enabled",
        },
        MONGODB_ORDER_NOT_FOUND: {
          status: 400,
          success: false,
          message: "MongoDB order not found",
          i18nKey: "backend.ecommerce.order.error.mongodb_order_not_found",
        },
        MSP_PAYMENT_FAILED: {
          status: 400,
          success: false,
          message:
            "MSP payment failed. Try again or a different payment method.",
          i18nKey: "backend.ecommerce.order.error.msp_payment_failed",
        },
        ORDER_NOT_FOUND: {
          status: 400,
          success: false,
          message: "Order not found",
          i18nKey: "backend.ecommerce.order.error.order_not_found",
        },
        NOT_AN_ECOMMERCE_ORDER: {
          status: 400,
          success: false,
          message:
            "This order was not found or is not an ecommerce order and cannot be handled here. Please contact the support.",
          i18nKey: "backend.ecommerce.order.error.not_an_ecommerce_order",
        },
        PAYMENT_CONDITIONS_NOT_MET: {
          status: 400,
          success: false,
          message: "Payment conditions not met",
          i18nKey: "backend.ecommerce.order.error.payment_conditions_not_met",
        },
        CAC_ORDER_NOT_CREATED: {
          status: 400,
          success: false,
          message: "CAC order not created",
          i18nKey: "backend.ecommerce.order.error.cac_order_not_created",
        },
        MONGODB_ORDER_NOT_CREATED: {
          status: 400,
          success: false,
          message: "MongoDB order not created",
          i18nKey: "backend.ecommerce.order.error.mongodb_order_not_created",
        },
        INVALID_PAYMENT_ATTEMPT: {
          status: 400,
          success: false,
          message: "Invalid payment attempt",
          i18nKey: "backend.ecommerce.order.error.invalid_payment_attempt",
        },
        MONGODB_ORDER_NOT_UPDATED: {
          status: 400,
          success: false,
          message: "Order not updated",
          i18nKey: "backend.ecommerce.order.error.mongodb_order_not_updated",
        },
        ORGANIZATION_CUSTOMER_ID_PENDING: {
          status: 400,
          success: false,
          message:
            "Your company account is still being set up. Please wait a few minutes, log out, log back in, and try again.",
          i18nKey:
            "backend.ecommerce.order.error.organization_customer_id_pending",
        },
        DISCOUNT_CODE_NO_LONGER_VALID: {
          status: 400,
          success: false,
          message:
            "Your discount code is no longer valid and has been removed from your cart. Please check your cart and try again.",
          i18nKey:
            "backend.ecommerce.order.error.discount_code_no_longer_valid",
        },
      },
    },

    PRODUCT: {
      GET_PRODUCT_GROUP_BY_NAME: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Product group fetched successfully",
          i18nKey:
            "backend.ecommerce.product.get_product_group_by_name.success",
        },

        ERROR: {
          PRODUCT_GROUP_NOT_FOUND: {
            status: 404,
            success: false,
            message: "Product group not found",
            i18nKey:
              "backend.ecommerce.product.get_product_group_by_name.error.product_group_not_found",
          },
        },
      },
      GET_PRODUCT_GROUPS_BY_NAMES: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Product groups fetched successfully",
          i18nKey:
            "backend.ecommerce.product.get_product_groups_by_names.success",
        },
      },
      GET_PRODUCT_GROUPS_BY_TAGS: {
        SUCCESS: {
          status: 200,
          success: true,
          message: "Product groups fetched successfully",
          i18nKey:
            "backend.ecommerce.product.get_product_groups_by_tags.success",
        },
      },
    },
  },
  MARKETING_TRACKER: {
    CREATE_MARKETING_TRACKER: {
      SUCCESS: {
        status: 200,
        success: true,
        message: "Marketing tracker created successfully",
        i18nKey: "backend.marketing_tracker.create_marketing_tracker.success",
      },
    },
  },
  EMAIL: {
    SEND_EMAIL: {
      SUCCESS: {
        status: 200,
        success: true,
      },
      ERROR: {
        SEND_EMAIL_FAILED: {
          status: 400,
          success: false,
          message: "Email sending failed",
          i18nKey: "backend.email.send_email.error.send_email_failed",
        },
      },
    },
  },
};

const getBackendResponse = (response) => {
  return response ?? BACKEND_RESPONSE.GENERAL?.ERROR?.UNKNOWN_ERROR;
};
module.exports = {
  BACKEND_RESPONSE,
  getBackendResponse,
};
